module.exports = __webpack_public_path__ + "img/logo-shopeepay.6c3fbf21.png";